import {createPopper} from "@popperjs/core";


const showEvents = ['mouseenter', 'focus'];
const hideEvents = ['mouseleave', 'blur', 'click'];

export function initPopper() {

    document.querySelectorAll('.popper-header').forEach(loadPopper);
}

function loadPopper(element) {

    const button = element
    let tooltip = element.childNodes[3];

    if(element.classList.contains('popper-loaded')) {
        return
    } else {
        element.classList.add('popper-loaded')
    }

    tooltip = element.querySelector('.popper-tooltip')

    // For DataTable buttons
    if(tooltip === undefined) {
        tooltip = element.firstChild.childNodes[1];
    }

    if(!tooltip) {
        return
    }

    let placement = tooltip.dataset.popperPlacement
    if(!placement) {
        placement = 'bottom'
    }

    const popperInstance = createPopper(button, tooltip, {
        placement: placement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
        ],
    });

    showEvents.forEach((event) => {
        button.addEventListener(event, function() {
            tooltip.setAttribute('data-show', '');
            popperInstance.update();
        });
    });

    hideEvents.forEach((event) => {
        button.addEventListener(event, function() {
            tooltip.removeAttribute('data-show');
        });
    });
}
